module.exports = __webpack_public_path__ + "img/plx.ad26534e.png";